﻿export class SloganContext {

    private readonly slogans = [
        'Where only the normals are broken',
        'Probably a polygon ...',
        'If it’s 3D, it’s probably us!',
        'Probably fun, definatly profitable',
        'Reckon it’s rendered',
        'Mesh maybe?',
        'Poly here, poly there, poly gone!',
        'From vertices to victories',
        'Don’t worry, it’s all vector-ious',
        'Maybe a mesh now',
        'Like a vertex, traced for the very first time',
        'Seems fully rigged',
        'Guess it’s geometry',
        'Always in the matrix'
    ]

    get() {
        return this.slogans[Math.floor(Math.random() * this.slogans.length)];
    }

}